<template>
  <div class="c-statitem">
    <img class="c-statitem__icon" :src="src"/>

    <div class="c-statitem__label">{{label}}</div>

    <div class="c-statitem__value">{{ Number.isNaN(value) ? 'ND' : value | toFixed(1) }}</div>

  </div>
</template>

<script>
import { toFixed } from '@/filters';

export default {
  name: 'OverviewItem',

  props: {
    src: String,
    label: String,
    value: Number
  },

  filters: {
    toFixed
  }
};
</script>

<style lang="scss" scoped>
.c-statitem {
  display: inline-block;
  margin: 20px;
  text-align: center;

  &__icon {
    height: 40px;
    margin-bottom: 5px;
  }
}
</style>
